(function () {
  'use strict';

  class SliderProductVariant {
    #controller;

    constructor(section) {
      this.section = section;
      this.track = section.querySelector('.tl-nbc__carousel');
      this.prevButton = section.querySelector('.tl-nbc__nav--prev');
      this.nextButton = section.querySelector('.tl-nbc__nav--next');

      if (!this.track) return;

      this.#controller = new AbortController();
      const { signal } = this.#controller;

      this.prevButton?.addEventListener('click', () => this.#scrollByCard(-1), { signal });
      this.nextButton?.addEventListener('click', () => this.#scrollByCard(1), { signal });
      this.track.addEventListener('scroll', () => this.#updateState(), { signal, passive: true });
      window.addEventListener('resize', () => this.#refresh(), { signal });

      this.#setupAddToCart(signal);
      this.#watchYotpo(signal);
      this.#refresh();
    }

    destroy() {
      this.#controller?.abort();
    }

    #refresh() {
      this.#checkOverflow();
      this.#updateState();
    }

    #checkOverflow() {
      const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 1;
      this.section.classList.toggle('tl-nbc--has-overflow', hasOverflow);
    }

    #scrollByCard(direction) {
      const card = this.track.querySelector('.tl-nbc__product');
      if (!card) return;

      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const distance = (card.getBoundingClientRect().width + gap) * direction;

      this.track.scrollBy({ left: distance, behavior: 'smooth' });
    }

    #updateState() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScroll = scrollWidth - clientWidth;

      if (this.prevButton) this.prevButton.style.display = scrollLeft <= 0 ? 'none' : '';
      if (this.nextButton) this.nextButton.style.display = scrollLeft >= maxScroll - 1 ? 'none' : '';
    }

    #setupAddToCart(signal) {
      this.section.querySelectorAll('.tl-nbc__add[data-variant-id]').forEach((btn) => {
        btn.addEventListener('click', () => this.#addToCart(btn), { signal });
      });
    }

    async #addToCart(btn) {
      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId || btn.disabled || btn.classList.contains('is-adding')) return;

      const originalLabel = btn.getAttribute('data-atc-label') || 'ADD TO BAG';
      btn.classList.add('is-adding');
      btn.disabled = true;
      btn.textContent = 'ADDING TO BAG...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        if (!response.ok) throw new Error('Add to cart failed');
        const data = await response.json();

        btn.textContent = 'ADDED ✓';
        btn.classList.remove('is-adding');
        btn.classList.add('is-added');

        this.#updateCartCount();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        setTimeout(() => {
          btn.textContent = originalLabel;
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 2000);
      } catch (error) {
        btn.textContent = originalLabel;
        btn.classList.remove('is-adding');
        btn.disabled = false;
      }
    }

    async #updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        document.dispatchEvent(new CustomEvent('cart:count-changed', { bubbles: true, detail: { count: cart.item_count } }));
      } catch (error) {
        // Silently ignore — cart count badge simply won't refresh this time.
      }
    }

    #watchYotpo(signal) {
      const widgets = this.section.querySelectorAll('.yotpo-widget-instance');
      if (!widgets.length) return;

      const observer = new MutationObserver(() => this.#refresh());
      widgets.forEach((widget) => observer.observe(widget, { childList: true, subtree: true }));

      signal.addEventListener('abort', () => observer.disconnect());
    }
  }

  document.querySelectorAll('[data-section-type="tl-newbest-carousel-3"]').forEach((section) => {
    new SliderProductVariant(section);
  });
})();
